module.exports = __webpack_public_path__ + "cfe70ab8e433b17e879628cd184f9a9b.pdf";